export default __webpack_public_path__ + "static/media/withdraw_success.c04ab1c4.svg";